// This file is used to handle some common items in myhoover.

(function ($) {
  $(function () {
    function handleCheckbox(pageTargetId) {
      $(document).on('change', '.myhoover ' + pageTargetId + ' input.red-checkbox', function () {
        let thisId = this.id, thisDataId = this.getAttribute('data-id');
        if (this.checked == true) {
          if (!$('.selected-topic-wrapper span[data-id=' + thisId + ']').length > 0) {
            appendCurrentChildTopics(pageTargetId, thisDataId, thisId);
          }
        } else {
          if ($('.selected-topic-wrapper span[data-id=' + thisId + ']').length > 0) {
            removeCurrentChildTopics(pageTargetId, thisId);
          }
        }

        if ($('.selected-topic-wrapper').find('.selected-topic').length > 0) {
          $(pageTargetId + ' .categories-wrap').show(500);
          $('.myhoover ' + pageTargetId + ' .clear-btn').show();
        } else {
          $('.myhoover ' + pageTargetId + ' .clear-btn').hide();
          $(pageTargetId + ' .categories-wrap').hide(500);
        }
      });
    }

    function crossBtnClick(pageId) {
      $(document).on('click', pageId + ' .selected-topic .close', function (e) {
        e.stopPropagation();
        const thisTagText = $(this).siblings('span').attr('data-id');
        $(this).closest('.selected-topic').remove();
        if($('html').hasClass('ua-firefox')){
          $(pageId + ' .col-three-card .check-box-wrap input:checkbox[id="' + thisTagText + '"]').siblings('label').trigger('click');
        } else {
          $(pageId + ' .col-three-card .check-box-wrap input:checkbox[id="' + thisTagText + '"]').trigger('click');
          let childCheckboxes = $(pageId + ' .check-box-wrap input.select-all-checkbox:checkbox[id="' + thisTagText + '"]').closest('.accordian-wrap').find('.accordian-body-outer');
          if (childCheckboxes.length > 0) {
            childCheckboxes.find('input.red-checkbox').trigger('click');
          } else { 
            $(pageId + ' .check-box-wrap input.select-all-checkbox:checkbox[id="' + thisTagText + '"]').trigger('click');
          }
        }
      });
    }

    function clearAllTags(pageId) {
      $('.myhoover ' + pageId + ' .clear-all').on('click', function () {
        $('.myhoover ' + pageId + ' .categories-wrap').each(function (){
          $(this).find('.selected-topic .close').trigger('click');
        });
        if ($('.selected-topic-wrapper').find('.selected-topic').length == 0) {
          $(this).closest('.clear-btn').hide();
        }
      });
    }

    function appendCurrentChildTopics(pageId, tagText, tagId) {
      const htmlString =
        '<div class="selected-topic">' +
        '<span data-id="' + tagId + '">' + tagText +"</span>" +
        '<div class="close">' + 
        '<svg data-name="Icon / X" xmlns="http://www.w3.org/2000/svg" width="16" height="16">' + '<g data-name="Group 7005">' + '<path data-name="Path 238" d="M0 0h16v16H0z" transform="rotate(90 8 8)" style="fill:none"></path>' +'<path data-name="Path 452" d="m0 0 10 10m0-10L0 10" transform="translate(3 3)" style="stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;fill:none"></path>' + "</g>" + "</svg>" +
        "</div>" +
        "</div>";
      $('.myhoover ' + pageId + ' .selected-topic-wrapper').append(htmlString);
    }

    function removeCurrentChildTopics(pageId, tagId) {
      if ($('.myhoover ' + pageId + ' .selected-topic-wrapper .selected-topic span[data-id=' + tagId + ']').length > 0) {
        $('.myhoover ' + pageId + ' .selected-topic-wrapper .selected-topic span[data-id=' + tagId + ']').parent().remove();
      }
    }

    function onSaveBtnOpenOverlay() {
      $('.myhoover .myhoover-save-btn').on('click', function () {
        $(".myhoover .my-feed-overlay").addClass('active');
      });
    }

    function selectAllCheckboxHandler(pageTargetId) {
      // this callback function is used for get select all checkbox click
      $(document).on('change', '.myhoover ' + pageTargetId + ' .select-all-checkbox', function (e) {
          e.stopPropagation();
        var $thisCheckbox = $(this).closest('.accordian-wrap').find('.accordian-body .check-box-wrap input.red-checkbox'),
          isChecked = false;
        if (isChecked == false) {
          $thisCheckbox.trigger('click');
        }

        $thisCheckbox.each(function () {
          $(this).not(this).prop('checked', this.checked);
          if ($(this).is(":checked")) {
            isChecked = true;
            return false;
          }
        });

        if ($(this).closest('.accordian-wrap').length > 0) {
          $(this).closest('.accordian-wrap').addClass('active');
          $(this).closest('.accordian-wrap').find(".accordian-body-outer").slideDown(500);
        }

        if (isChecked) {
          $thisCheckbox.prop('checked', false);
          $thisCheckbox.trigger('click');
        } else {
          $thisCheckbox.prop('checked', true);
          $thisCheckbox.trigger('click');
        }
      });

      // this callback function is used for get child checkboxes click to trigger select all box
      $(document).on('change', '.myhoover ' + pageTargetId + ' .red-checkbox:checkbox', function () {
        var $thisCheckbox = $(this).closest('.accordian-wrap').find('.accordian-body .check-box-wrap input.red-checkbox');

        $thisCheckbox.each(function () {
          if (!$(this).is(":checked")) {
            $(this).closest('.accordian-wrap').find('.accordian-head .select-all-checkbox').prop('checked', false);
            return false;
          } else {
            $(this).closest('.accordian-wrap').find('.accordian-head .select-all-checkbox').prop('checked', true);
          }
        });
      });
    }

    if ($('.myhoover-save-btn').length > 0) {
      onSaveBtnOpenOverlay();
    }

    if ($('#my-hoover-multimedia').length > 0) {
      clearAllTags('#my-hoover-multimedia');
      crossBtnClick('#my-hoover-multimedia');
      handleCheckbox('#my-hoover-multimedia');
    }

    if ($('#myhoover-feed-topics').length > 0) {
      clearAllTags('#myhoover-feed-topics');
      crossBtnClick('#myhoover-feed-topics');
      handleCheckbox('#myhoover-feed-topics');
    }

    if ($('#my-hoover-publications').length > 0) {
      clearAllTags('#my-hoover-publications');
      crossBtnClick('#my-hoover-publications');
      handleCheckbox('#my-hoover-publications');
      selectAllCheckboxHandler('#my-hoover-publications');
    }

  });
})(jQuery);